import React from "react";
import { Card, Table, Spinner, Badge } from "react-bootstrap";
import { formatPrice } from "utils/utils";
import { useDailySummary } from "./useDailySummary";

const DailySummaryCard = ({ filters = {} }) => {
  const { dailySummary, isLoading, error } = useDailySummary(filters);

  if (isLoading) {
    return (
      <Card>
        <Card.Body className="text-center">
          <Spinner animation="border" size="sm" className="me-2" />
          Loading daily summary...
        </Card.Body>
      </Card>
    );
  }

  if (error) {
    return (
      <Card>
        <Card.Body>
          <Card.Title className="text-danger">Error loading summary</Card.Title>
          <p className="text-muted">{error.message}</p>
        </Card.Body>
      </Card>
    );
  }

  const {
    summary = [],
    grandTotal = 0,
    totalTransactions = 0,
    date,
  } = dailySummary || {};

  return (
    <Card>
      <Card.Body>
        <Card.Title className="d-flex justify-content-between align-items-center">
          Summary Count Transaction/Payment Method
          <Badge bg="primary text-white" pill>
            {new Date(date).toLocaleDateString("id-ID")}
          </Badge>
        </Card.Title>

        {summary.length > 0 ? (
          <>
            <Table striped bordered hover size="sm" className="mb-3">
              <thead className="table-dark">
                <tr>
                  <th>Payment Method</th>
                  <th className="text-center">Count</th>
                  <th className="text-end">Total Amount</th>
                </tr>
              </thead>
              <tbody>
                {summary.map((item, index) => (
                  <tr key={index}>
                    <td>
                      <strong>{item.paymentMethod}</strong>
                    </td>
                    <td className="text-center">
                      <Badge bg="info text-white">{item.count}</Badge>
                    </td>
                    <td className="text-end">
                      {formatPrice(item.totalAmount)}
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot className="table-secondary">
                <tr>
                  <td>
                    <strong>TOTAL</strong>
                  </td>
                  <td className="text-center">
                    <Badge bg="success text-white" pill>
                      {totalTransactions}
                    </Badge>
                  </td>
                  <td className="text-end">
                    <strong>{formatPrice(grandTotal)}</strong>
                  </td>
                </tr>
              </tfoot>
            </Table>

            {/* Summary stats */}
            <div className="row text-center">
              <div className="col-md-4">
                <div className="border rounded p-2">
                  <h6 className="text-muted mb-1">Total Transactions</h6>
                  <h4 className="text-primary mb-0">{totalTransactions}</h4>
                </div>
              </div>
              <div className="col-md-4">
                <div className="border rounded p-2">
                  <h6 className="text-muted mb-1">Payment Methods</h6>
                  <h4 className="text-info mb-0">{summary.length}</h4>
                </div>
              </div>
              <div className="col-md-4">
                <div className="border rounded p-2">
                  <h6 className="text-muted mb-1">Grand Total</h6>
                  <h4 className="text-success mb-0">
                    {formatPrice(grandTotal)}
                  </h4>
                </div>
              </div>
            </div>
          </>
        ) : (
          <div className="text-center py-4">
            <div className="text-muted">
              <i className="fas fa-receipt fa-3x mb-3"></i>
              <h5>No transactions today</h5>
              <p>
                No transactions found for{" "}
                {new Date(date).toLocaleDateString("id-ID")}
              </p>
            </div>
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default DailySummaryCard;
